import { render, staticRenderFns } from "./roleSetting.vue?vue&type=template&id=1221a528&scoped=true"
import script from "./roleSetting.vue?vue&type=script&lang=js"
export * from "./roleSetting.vue?vue&type=script&lang=js"
import style0 from "./roleSetting.vue?vue&type=style&index=0&id=1221a528&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221a528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1221a528')) {
      api.createRecord('1221a528', component.options)
    } else {
      api.reload('1221a528', component.options)
    }
    module.hot.accept("./roleSetting.vue?vue&type=template&id=1221a528&scoped=true", function () {
      api.rerender('1221a528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/roleSetting.vue"
export default component.exports